import {pushEdapEvent} from '../../utils/edap';

export const ACTION_LOCATION = 'properties-module';

export function handleNext() {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.next.click', edapData);

    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'next arrow clicked',
    });
}

export function handlePrev() {
    const edapData = {
        actionlocation: ACTION_LOCATION,
    };

    pushEdapEvent('nav.previous.click', edapData);

    pushEdapEvent('ux.cards_visible.adjusted', {
        action_location: ACTION_LOCATION,
        event_action: 'previous arrow clicked',
    });
}
